import React from 'react'
import { Field } from 'redux-form'
import { Button } from 'react-bootstrap'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { COLORES } from '../../../../config/colores'

function EgresoCaladoQRLecturaScan (props) {
  const { handleSubmit } = props

  return (
    <>
      <form
        onSubmit={handleSubmit}
        style={{ width: '98%' }}
      >
        <Field
          style={{ height: '50px' }}
          className='numero'
          name='numero'
          type='text'
          label=' '
          maxLength={11}
          component={renderTextField}
          autoFocus
          onBlur={() => document.activeElement.blur()}
          placeholder='10200000000'
        />
        <Button
          type='submit'
          style={{ marginTop: '18px', backgroundColor: COLORES.grey.dark, color: '#ffffff' }}
        >
                                    Egresar
        </Button>
      </form>
    </>
  )
}

export default EgresoCaladoQRLecturaScan
